module.exports = __webpack_public_path__ + "img/A18b_FRENCH_REF PAM NA 9330-08 C2 R4 1992_FRENCH.63d2a912.jpg";